module.exports = __webpack_public_path__ + "img/graph-purple.524746a9.png";